module.exports = __webpack_public_path__ + "img/gto.366c43e9.svg";